import React, {useEffect, useState} from 'react';
import {LineDiv, SectionDiv, Text} from "./design";
import ConstructionSiteApi from "../API/constructionSiteApi";

const ConstructionSiteDayWorks = ({Data, setData, selectedFloor, selectedHouse}) => {
    const [selectedWorkType, setSelectedWorkType]=useState(null)
    const [WorkTypes, setWorkTypes]=useState(null);
    function changeWorkType(event){

        const WorkTypeId=event.currentTarget.id;
        const WorkTypeName=event.currentTarget.getAttribute("data-work-type-name")

        let TempData=Data;

        if(!TempData[selectedHouse].Floors[selectedFloor].WorkTypes[WorkTypeName])  TempData[selectedHouse].Floors[selectedFloor].WorkTypes[WorkTypeName]={WorkTypeId:WorkTypeId, Works:[],Count:0};
        if(selectedWorkType&&TempData[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName].Works.length ===0) {
            delete TempData[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName]
        }
        if(selectedWorkType&&selectedWorkType.WorkTypeId == WorkTypeId) {
            setSelectedWorkType(null)
            return
        }
        setSelectedWorkType({WorkTypeName:WorkTypeName, WorkTypeId:WorkTypeId})
        localStorage.setItem("Data",JSON.stringify(TempData))
        setData({...TempData});
    }
    function findWorkIndex(WorkId, WorkArray){
        let WorkIndex=-1
        WorkArray.map((Element, Index)=>{
            if(Element.WorkId == WorkId)
                WorkIndex=Index
        })
        return WorkIndex
    }
    function changeWork(event){
        const WorkId=event.currentTarget.id;
        const WorkName=event.currentTarget.getAttribute("data-work-name")
        let TempData=Data;

        const Index=findWorkIndex(WorkId, TempData[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName].Works);

        if(Index>-1)
            TempData[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName].Works.splice(Index,1)
        else
            TempData[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName].Works.push({WorkId:WorkId, WorkName:WorkName})

        if(TempData[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName].Works.length === 0) {
            delete TempData[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName]
            setSelectedWorkType(null)
        }
        localStorage.setItem("Data",JSON.stringify(TempData))
        setData({...TempData})
    }
    function changeCount(event){
        let Count=event.currentTarget.id
        let TempData=Data;

        TempData[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName].Count = Count

        localStorage.setItem("Data",JSON.stringify(TempData))
        setData({...TempData})
    }
    function findWorkType(WorkTypeName, WorkTypeArray){
        if(WorkTypeName)
        for(let Element of WorkTypeArray){
            if(Element.WorkTypeName == WorkTypeName)
               return Element.Works;

        }
    }
    useEffect(() => {
        ConstructionSiteApi.getAllWorksTypes()
            .then((Result)=>{
                if(Result.Status) {
                    let TempWorkTypes = [];
                    if(Result.Status)
                    for(Element in Result.WorkTypes) {
                        TempWorkTypes.push({WorkTypeId:Result.WorkTypes[Element].WorkTypeId,WorkTypeName:Element, Works:Result.WorkTypes[Element].Works})
                    }
                    setWorkTypes(TempWorkTypes)
                }
            })
    }, []);
    useEffect(() => {
        setSelectedWorkType(null)
    }, [selectedFloor]);
    console.log(WorkTypes)
    return(
        <>
            <SectionDiv clickable={selectedFloor?"auto":"none"} visible={selectedFloor?"grid":"none"}>
                {
                    selectedFloor&&WorkTypes&&WorkTypes.map(Element=>{
                        let checked=false;
                        if(Data[selectedHouse].Floors[selectedFloor].WorkTypes[Element.WorkTypeName]) checked=true
                        return (
                            <LineDiv key={Element.WorkTypeId} id={Element.WorkTypeId} data-work-type-name={Element.WorkTypeName} onClick={changeWorkType}>
                                <input id={Element.Id} type='checkbox' checked={checked}/>
                                <Text>{Element.WorkTypeName}</Text>
                            </LineDiv>
                        )
                    })
                }
            </SectionDiv>
            <SectionDiv clickable={selectedWorkType?"auto":"none"} visible={selectedWorkType?"grid":"none"}>
                {
                    selectedFloor&&selectedWorkType&&findWorkType(selectedWorkType.WorkTypeName, WorkTypes).map(Element=>{
                        let checked=false;
                        try {
                            if (findWorkIndex(Element.WorkId, Data[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName].Works) > -1) checked = true
                            return (
                                <LineDiv key={Element.WorkName} id={Element.WorkId} data-work-name={Element.WorkName}
                                         onClick={changeWork}>
                                    <input id={Element.WorkId} type='checkbox' checked={checked}/>
                                    <Text>{Element.WorkName}</Text>
                                </LineDiv>
                            )
                        }catch(Err){}
                    })
                }
            </SectionDiv>
            <SectionDiv clickable={selectedFloor?"auto":"none"} visible={selectedWorkType&&Data[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName]?.Works?.length>0?"grid":"none"}>
                {
                    selectedFloor&&[1,2,3,4,5,6,7,8,9].map(Element=>{
                        let checked=false;
                        try {
                            if (selectedWorkType && Data[selectedHouse].Floors[selectedFloor].WorkTypes[selectedWorkType.WorkTypeName].Count == Element) checked = true
                            return (
                                <LineDiv key={Element} id={Element} onClick={changeCount}>
                                    <input id={Element} type='checkbox' checked={checked}/>
                                    <Text>{Element}</Text>
                                </LineDiv>
                            )
                        }catch(Err){}
                    })
                }
            </SectionDiv>
        </>
    )
};

export default ConstructionSiteDayWorks;